import {
  emptyValidator,
  formValidator,
  emailMenValidator,
  mobilePhoneMenValidator,
  mobilePhoneNotMenValidator,
  nicValidator,
  nicNonMandatoryValidator,
} from "../../validators";

// const stakeholderValidationStatus = {
//   stkName: {
//     validators: [emptyValidator()],
//     name: "Name",
//   },
//   stkGroups: {
//     validators: [emptyValidator()],
//     name: "Group",
//   },
//   stkStatus: {
//     validators: [emptyValidator()],
//     name: "Status",
//   },
//   stkActive: {
//     validators: [emptyValidator()],
//     name: "Active",
//   },
// };

export const stakeholderValidation = (
  stakeholder,
  stakeholderValidationStatus,
) => {
  return formValidator(stakeholder, stakeholderValidationStatus);
};

export const dynamicFinanceInfoValidationState = {
  finCashType: {
    validators: [emptyValidator()],
    name: "Cash Type",
  },
  finCreditFrom: {
    validators: [emptyValidator()],
    name: "Credit From",
  },
  finCreditTo: {
    validators: [emptyValidator()],
    name: "Credit To",
  },
  finRemainingCredit: {
    validators: [emptyValidator()],
    name: "Remaining Credit",
  },
  finRemainingOutstanding: {
    validators: [emptyValidator()],
    name: "Remaining Outstanding",
  },
  finTaxType: {
    validators: [emptyValidator()],
    name: "Tax Type",
  },
  finTaxRegistration: {
    validators: [emptyValidator()],
    name: "Tax Registration",
  },
  finCompanyRegistration: {
    validators: [emptyValidator()],
    name: "Company Registration",
  },
  finSvatType: {
    validators: [emptyValidator()],
    name: "SVAT Type",
  },
  finCurrency: {
    validators: [emptyValidator()],
    name: "Currency",
  },
  finBank: {
    validators: [emptyValidator()],
    name: "Bank",
  },
  finBranch: {
    validators: [emptyValidator()],
    name: "Branch",
  },
  finAccNo: {
    validators: [emptyValidator()],
    name: "Account No",
  },
  finAccBeneficiary: {
    validators: [emptyValidator()],
    name: "Account Beneficiary",
  },
  finBillingCustomer: {
    validators: [emptyValidator()],
    name: "Billing Customer",
  },
  finInvoicingCustomer: {
    validators: [emptyValidator()],
    name: "Invoicing Customer",
  },
  finStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  finActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  finCreditAmount: {
    validators: [emptyValidator()],
    name: "Credit Amount",
  },
};

export const dynamicContactValidationStatus = {
  conPhoneSecond: {
    validators: [mobilePhoneNotMenValidator()],
    name: "Phone 2",
  },
  conWhatsappNo: {
    validators: [mobilePhoneNotMenValidator()],
    name: "Whatsapp No",
  },
  conAddress2: {
    validators: [emptyValidator()],
    name: "Address 2",
  },
  conAddress3: {
    validators: [emptyValidator()],
    name: "Address 3",
  },
  conZip: {
    validators: [emptyValidator()],
    name: "Zip",
  },
  conSecAddress: {
    validators: [emptyValidator()],
    name: "Address",
  },
  conSecAddress2: {
    validators: [emptyValidator()],
    name: "Address 2",
  },
  conSecAddress3: {
    validators: [emptyValidator()],
    name: "Address 3",
  },
  conSecState: {
    validators: [emptyValidator()],
    name: "State",
  },
  conSecDistrict: {
    validators: [emptyValidator()],
    name: "District",
  },
  conSecZip: {
    validators: [emptyValidator()],
    name: "Zip",
  },
  conSecCity: {
    validators: [emptyValidator()],
    name: "City",
  },
  conSecCountry: {
    validators: [emptyValidator()],
    name: "Country",
  },
  conLon: {
    validators: [emptyValidator()],
    name: "Lon",
  },
  conLat: {
    validators: [emptyValidator()],
    name: "Lat",
  },
  conType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  conTitle: {
    validators: [emptyValidator()],
    name: "Title",
  },
  conName: {
    validators: [emptyValidator()],
    name: "Name",
  },
  conDepartment: {
    validators: [emptyValidator()],
    name: "Department",
  },
  conMobile: {
    validators: [mobilePhoneMenValidator()],
    name: "Mobile",
  },
  conPhone: {
    validators: [mobilePhoneNotMenValidator()],
    name: "Phone 1",
  },
  conEmail: {
    validators: [emailMenValidator()],
    name: "Email",
  },
  conAddress: {
    validators: [emptyValidator()],
    name: "Address",
  },
  conState: {
    validators: [emptyValidator()],
    name: "State",
  },
  conDistrict: {
    validators: [emptyValidator()],
    name: "District",
  },
  conCity: {
    validators: [emptyValidator()],
    name: "City",
  },
  conCountry: {
    validators: [emptyValidator()],
    name: "Country",
  },
  conStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  conActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  conNic: {
    validators: [nicNonMandatoryValidator()],
    name: "NIC",
  },
};

const contactValidationStatus = {
  conType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  conTitle: {
    validators: [emptyValidator()],
    name: "Title",
  },
  conName: {
    validators: [emptyValidator()],
    name: "Name",
  },
  conDepartment: {
    validators: [emptyValidator()],
    name: "Department",
  },
  conMobile: {
    validators: [mobilePhoneMenValidator()],
    name: "Mobile",
  },
  conPhone: {
    validators: [mobilePhoneNotMenValidator()],
    name: "Phone 1",
  },
  conEmail: {
    validators: [emailMenValidator()],
    name: "Email",
  },
  conNic: {
    validators: [nicValidator()],
    name: "ID Number",
  },
  conAddress: {
    validators: [emptyValidator()],
    name: "Address",
  },
  conState: {
    validators: [emptyValidator()],
    name: "State",
  },
  conDistrict: {
    validators: [emptyValidator()],
    name: "District",
  },
  conCity: {
    validators: [emptyValidator()],
    name: "City",
  },
  conCountry: {
    validators: [emptyValidator()],
    name: "Country",
  },
  conStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  conActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

export const contactValidation = (contactData) => {
  return formValidator(contactData, contactValidationStatus);
};

export const dynamicContactValidation = (contactData, validationStatus) => {
  return formValidator(contactData, validationStatus);
};

export const dynamicFinanceInfoValidation = (financeData, validationStatus) => {
  return formValidator(financeData, validationStatus);
};

// const clusterValidationStatus = {
//   cluCluster: {
//     validators: [emptyValidator()],
//     name: "Cluster",
//   },
//   cluActive: {
//     validators: [emptyValidator()],
//     name: "Active",
//   },
//   cluStatus: {
//     validators: [emptyValidator()],
//     name: "Status",
//   },
// };

export const clusterValidation = (clusterData, clusterValidationStatus) => {
  return formValidator(clusterData, clusterValidationStatus);
};

const typeValidationStatus = {
  typType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  typActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

export const typeValidation = (typeData) => {
  return formValidator(typeData, typeValidationStatus);
};

// const financeInfoValidationStatus = {
//   finStatus: {
//     validators: [emptyValidator()],
//     name: "Status",
//   },
//   finActive: {
//     validators: [emptyValidator()],
//     name: "Active",
//   },
// };

export const financeInfoValidation = (
  financeInfo,
  financeInfoValidationStatus,
) => {
  return formValidator(financeInfo, financeInfoValidationStatus);
};

export const consignmentTypeValidation = (
  consignmentType,
  consignmentTypeValidationStatus,
) => {
  return formValidator(consignmentType, consignmentTypeValidationStatus);
};

// const operationDataValidationStatus = {
//   spyType: {
//     validators: [emptyValidator()],
//     name: "Type",
//   },
//   spyActive: {
//     validators: [emptyValidator()],
//     name: "Active",
//   },
// };

export const operationDataValidation = (
  operationData,
  operationDataValidationStatus,
) => {
  return formValidator(operationData, operationDataValidationStatus);
};

// const configDataValidationStatus = {};

export const configDataValidation = (
  configData,
  configDataValidationStatus,
) => {
  return formValidator(configData, configDataValidationStatus);
};

const documentValidationStatus = {
  docCategory: {
    validators: [emptyValidator()],
    name: "Category",
  },
  fileType: {
    validators: [emptyValidator()],
    name: "File Type",
  },
  fileName: {
    validators: [emptyValidator()],
    name: "File Type",
  },
  docActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  docStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  docName: {
    validators: [emptyValidator()],
    name: "Document Name",
  },
};

export const documentValidation = (document) => {
  return formValidator(document, documentValidationStatus);
};
